module.exports = __webpack_public_path__ + "img/feature-2.f4c8e1d0.png";